var data = {
  body:
    '<g transform="matrix(0.182642,0,0,0.182642,0.193418,6.17895)"><path d="M65.697,83L72.697,90L51.697,90L27.697,112L161.697,112L137.697,90L109.697,90L117.697,83L142.697,83L188.514,122L1,122L46.697,83L65.697,83ZM175.888,18.187L159.723,1.97L91.827,70.095L65.962,44.143L49.8,60.363L91.827,102.535L175.888,18.187Z" style="fill-rule:nonzero;" fill="currentColor"/></g>',
  width: 35,
  height: 35,
};

export default data;
